import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { Http, Auth } from '../../support';
import { fetchAuthMe } from '../../shared/session';
import Loading from '../../facturotopia/loading/Loading';
import ResponseError from '../../shared/responses/ResponseError';
import { Container, Image } from 'react-bootstrap';

class AuthConnect extends Component {

  state = {}

  constructor(props) {
    super(props);

    this.state = {
      busy: false
    };
  }

  componentDidMount() {
    const { search = '' } = this.props.location || {};

    this.setState({
      busy: true,
      message: 'Preparando app...'
    });

    Http.get(search.replace('?next=', ''))
      .then(async (token) => {
        await Auth.setData({
          token: token.data,
          user: {},
          cliente: {}
        });

        this.setState({
          busy: true,
          message: 'Casi terminamos, creando tu sesión...'
        });

        const response = await fetchAuthMe();

        const userData = Auth.getData();

        const user = {
          ...response.data,
          empresa: undefined,
          cliente: undefined,
          emisor: undefined,
        };

        const { empresa, emisor, cliente } = response.data;

        const data = {
          ...userData,
          user,
          empresa: empresa || {},
          emisor: emisor || {},
          cliente: cliente || {},
        };

        await Auth.setData(data);

        this.setState({
          busy: false
        });

        this.props.history.push('/bridge');
      }, (error) => {
        this.setState({
          error: error.data || error,
          showError: true
        });
      })
      .finally(() => {
        this.setState({
          busy: false
        })
      })
  }

  handleOnAction = (action: string) => {
    this.setState({
      showError: false
    });
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          variant="inline"
          title="Error"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  render() {
    const { busy, redirect, error, message, showError } = this.state;

    if (redirect) {
      const from = { from: { pathname: '/app/dashboard' } };

      return <Redirect to="/bridge" state={ from } />;
    }

    return (
      <Container className="auth-layout-container" fluid>
        <div className="auth-content h-auto">
          <div className="avatar mt-4">
            <div className="auth-logo">
              <div className="d-flex justify-content-start">
                  <Image src="/img/logo.png"
                    className="auth-logo-img opacity-6"
                    fluid={ true }
                  />
                  <p className="title text-muted">Facturotöpia</p>
              </div>
              <div>
                <p className="subtitle">
                  Regístrate, factura, personaliza... despreocúpate.
                </p>
              </div>
            </div>
          </div>
          <div className="text-center">

            <div className="pt-32">
              { !error && (
                <strong className="text-info">
                  { message }
                </strong>
              )}

              { !!error && !error.errors && (
                <strong className="text-danger">
                  { error.message || 'No podemos verificar tu cuenta, contacta a soporte.' }
                </strong>
              )}
            </div>

            { !!showError && !!error.errors && this.renderError() }

            { busy && (
              <div className="py-5">
                <Loading center />
              </div>
            )}
          </div>
        </div>
      </Container>
    );
  }

}

export default AuthConnect;